import { Button } from '@lmig/lmds-react-button';
import './HorizontalPerk.scss';
import { triggerGoal } from 'Utilities/GoalManager';
import { useEffect, useState } from 'react';
import UpdateObjectCTA from './UpdateObjectCTA';
import { IHorizontalPerk } from './Models/HorizontalPerkModels';

const HorizontalPerk = (props: IHorizontalPerk) => {
  const [renderButton, setRenderButton] = useState(false);
  const [renderCTA, setRenderCTA] = useState(false);

  const richText = props.richText?.replace('&lsquo;', "'").replace('&rsquo;', "'");

  useEffect(() => {
    //priority to rendering CTA
    if (props.cta && props.cta.ctaButton && props.cta.ctaButton !== '') {
      setRenderCTA(true);
    } else if (props.buttonURL && props.buttonText) {
      setRenderButton(true);
    }
  }, [props.buttonURL, props.buttonText, props.cta]);

  return (
    <div
      className={props.oneThirdWidthVariant ? 'horizontal-perk-container-one-third' : 'horizontal-perk-container'}
      style={{
        backgroundImage: `url(${
          props.oneThirdWidthVariant
            ? '/-/media/Project/Safeco/shared/Rewards/one-third-background_396x256.jpg'
            : '/-/media/Project/Safeco/shared/Rewards/BL-Horizontal-perk-background_824x110px.jpg'
        })`,
      }}
    >
      <div className="horizontal-perk-content">
        <div className="horizontal-perk-rich-text" dangerouslySetInnerHTML={{ __html: richText }} />
        {renderButton && (
          <div className="horizontal-perk-button">
            <Button
              size="small"
              variant="primary"
              href={props.buttonURL}
              onClick={() => triggerGoal(props.buttonGoal)}
              alt={props.buttonText}
              target={props.linkTarget}
              data-testid="horizontal-perk-button-test"
            >
              {props.buttonText}
            </Button>
          </div>
        )}
        {renderCTA && (
          <div className="horizontal-perk-button">
            <UpdateObjectCTA
              modalText={props.cta.modalText}
              closeButton={props.cta.closeButton}
              closeButtonGoal={props.cta.closeButtonGoal}
              ctaButton={props.cta.ctaButton}
              ctaButtonGoal={props.cta.ctaButtonGoal}
              rewardId={props.cta.rewardId}
              modalTitle={props.cta.modalTitle}
              size={'small'}
              data-testid="horizontal-perk-cta-test"
            ></UpdateObjectCTA>
          </div>
        )}
      </div>
    </div>
  );
};
export default HorizontalPerk;
